import React from "react";
import { IPhaseHeaderProps, usePhaseHeaderController } from "./hooks/usePhaseHeaderController";
import { PhaseHeaderView } from "./components/PhaseHeaderView";

// Always-visible phase header for tasks with the extended header setting (controller/hook/view
// pattern). Workflow-neutral: which columns appear is driven by the
// showProgress/showSubmission/showCompletion props.
export default function PhaseHeader(props: IPhaseHeaderProps) {
    const ctrl = usePhaseHeaderController(props);
    return <PhaseHeaderView {...ctrl} />;
}
